import TrackServicesIndex from "@/components/TrackServicesIndex";
import { INDUSTRIAL_SERVICES_DATA } from "@/data/industrial-services";
import { PAGE_META } from "@/lib/seo-constants";

export default function IndustrialServices() {
    return (
        <TrackServicesIndex
            trackKey="industrial"
            servicesData={INDUSTRIAL_SERVICES_DATA}
            meta={PAGE_META.industrialServices}
            intro={{
                title: "Heavy-duty industrial site & facility services.",
                body: "Truck-rated paving, heavy concrete, security fencing, structural masonry, retaining structures, bollards and drainage — engineered for load and compliance.",
            }}
        />
    );
}
